import {Quantity} from "@/model/Quantity";
import {OrderedProductStatus} from "@/model/OrderedProductStatus";
import { Serializable, SerializationHelper } from "@/helpers/SerializationHelper";
import {VariableMeasurement} from "@/model/order/VariableMeasurement";

export class OrderProduct implements Serializable {
    orderLineNumber: number;
    cug: string;
    codePlu: string;
    label: string;
    origin: string;
    thumbnail: string;
    quantity: Quantity;
    processedQuantity: Quantity;
    isReady: boolean = false;
    status: OrderedProductStatus;
    inStockToday: boolean = true;
    zoneCode: string;
    withDelay: boolean = false;
    totalPrice: number;
    variableMeasurement: VariableMeasurement;
    isSubstituted: boolean = false;

    fromJSON(obj: any) {
        SerializationHelper.copyNonExcludedProperties(this, obj, []);
        if (this.processedQuantity == null) {
            this.processedQuantity = new Quantity(0, this.quantity?.unit);
        }
    }

    get isScannable(): boolean {
        return this.variableMeasurement != null;
    }
}